module.exports = __webpack_public_path__ + "static/media/dp1.cda2189b.webp";